import { createFileRoute } from "@tanstack/react-router";
import SelectOrgPage from "@/features/select-org/SelectOrgPage";

export const Route = createFileRoute("/_org-setup/select-org")({
  component: SelectOrgPage,
});
